import { GoogleAPIPlace } from 'models/purchaseFlow'

/** Gets city from Google API Place */
export const getCityFromGooglePlace = (googlePlace: GoogleAPIPlace | null | undefined) => {
  return googlePlace?.address_components?.find(el => el.types.includes('locality') && el.types.includes('political'))?.long_name || null
}